// connectors/binanceWallet/binanceWallet.ts
import { createConnector } from "wagmi";
var mappingNetwork = {
  1: "eth-mainnet",
  56: "bsc-mainnet",
  97: "bsc-testnet"
};
var _binanceChainListener = async () => new Promise(
  (resolve) => Object.defineProperty(window, "BinanceChain", {
    get() {
      return this.bsc;
    },
    set(bsc) {
      this.bsc = bsc;
      resolve();
    }
  })
);
function binanceWallet() {
  return createConnector((config) => ({
    id: "bsc",
    name: "Binance Wallet",
    type: "injected",
    async connect({ chainId } = {}) {
      var _a;
      const provider = await this.getProvider();
      if (!provider)
        throw new Error("Binance Wallet not found");
      const accounts = await provider.request({ method: "eth_requestAccounts" });
      let currentChainId = await this.getChainId();
      if (chainId && currentChainId !== chainId && mappingNetwork[chainId]) {
        await ((_a = this.switchChain) == null ? void 0 : _a.call(this, { chainId }));
        currentChainId = chainId;
      }
      return { accounts, chainId: currentChainId };
    },
    async disconnect() {
      var _a, _b, _c;
      const provider = await this.getProvider();
      if (!provider)
        return;
      (_a = provider.removeListener) == null ? void 0 : _a.call(provider, "accountsChanged", this.onAccountsChanged.bind(this));
      (_b = provider.removeListener) == null ? void 0 : _b.call(provider, "chainChanged", this.onChainChanged.bind(this));
      (_c = provider.removeListener) == null ? void 0 : _c.call(provider, "disconnect", this.onDisconnect.bind(this));
    },
    async getAccounts() {
      const provider = await this.getProvider();
      if (!provider)
        return [];
      const accounts = await provider.request({ method: "eth_accounts" });
      return accounts;
    },
    async getChainId() {
      var _a, _b;
      const provider = await this.getProvider();
      if (!provider)
        return (_b = (_a = config.chains[0]) == null ? void 0 : _a.id) != null ? _b : 56;
      const chainId = await provider.request({ method: "eth_chainId" });
      return Number(chainId);
    },
    async getProvider() {
      if (typeof window === "undefined")
        return void 0;
      if (window.BinanceChain)
        return window.BinanceChain;
      await _binanceChainListener();
      return window.BinanceChain;
    },
    async isAuthorized() {
      try {
        const accounts = await this.getAccounts();
        return accounts.length > 0;
      } catch {
        return false;
      }
    },
    async switchChain({ chainId }) {
      var _a, _b;
      const provider = await this.getProvider();
      if (!provider)
        throw new Error("Binance Wallet not found");
      if (!mappingNetwork[chainId]) {
        throw new Error(`Chain ${chainId} not supported by Binance Wallet`);
      }
      try {
        await ((_a = provider.switchNetwork) == null ? void 0 : _a.call(provider, mappingNetwork[chainId]));
        return (_b = config.chains.find((c) => c.id === chainId)) != null ? _b : { id: chainId, name: `Chain ${chainId}` };
      } catch (error) {
        if ((error == null ? void 0 : error.error) === "user rejected")
          throw new Error("User rejected");
        throw error;
      }
    },
    onAccountsChanged(accounts) {
      if (accounts.length === 0)
        config.emitter.emit("disconnect");
      else
        config.emitter.emit("change", { accounts });
    },
    onChainChanged(chain) {
      config.emitter.emit("change", { chainId: Number(chain) });
    },
    onDisconnect() {
      config.emitter.emit("disconnect");
    }
  }));
}
export {
  binanceWallet
};
